export const DEPARTMENTS = ["Engineering", "Hardware & IoT", "Operations", "Sales & Marketing", "HR & Admin", "Finance"];

export const LEAVE_TYPES = { casual: "Casual", sick: "Sick", earned: "Earned", unpaid: "Unpaid (LOP)" };

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export const fmtDate = (s) =>
  s ? new Date(s.length === 10 ? `${s}T00:00:00` : s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const fmtTime = (s) =>
  s ? new Date(s.endsWith("Z") || s.includes("+") ? s : `${s}Z`).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" }) : "—";

export const monthLabel = (m) => {
  if (!m) return "—";
  const [y, mo] = m.split("-");
  return new Date(+y, +mo - 1, 1).toLocaleDateString("en-IN", { month: "long", year: "numeric" });
};

export const currentMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

const two = (n) => (n < 20 ? ONES[n] : `${TENS[Math.floor(n / 10)]} ${ONES[n % 10]}`.trim());
const three = (n) => (n >= 100 ? `${ONES[Math.floor(n / 100)]} Hundred ${two(n % 100)}`.trim() : two(n));

export function toWordsINR(num) {
  let n = Math.round(num || 0);
  if (n === 0) return "Zero Rupees Only";
  const parts = [];
  const units = [[10000000, "Crore"], [100000, "Lakh"], [1000, "Thousand"]];
  for (const [v, label] of units) {
    if (n >= v) {
      parts.push(`${three(Math.floor(n / v))} ${label}`);
      n %= v;
    }
  }
  if (n) parts.push(three(n));
  return `${parts.join(" ")} Rupees Only`;
}

export const genPassword = () => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
  let p = "";
  for (let i = 0; i < 8; i++) p += chars[Math.floor(Math.random() * chars.length)];
  return `${p}@1`;
};
